import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=cdf1f25a&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdf1f25a')) {
      api.createRecord('cdf1f25a', component.options)
    } else {
      api.reload('cdf1f25a', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=cdf1f25a&", function () {
      api.rerender('cdf1f25a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2B72eL5gGpKkp/JS/comp/ImgFallback.vue"
export default component.exports